export default "__VITE_ASSET__50a41228__"